<template>
    <header class="header">
        <div class="header__mobile d-block d-xl-none">
          <div class="row justify-content-between align-items-center">
            <div class="col-auto">
              <button class="btn header__open" @click.prevent="openMenu" type="button" :aria-label='$t("openMenu")'>
                <svg role="img" width="24" height="24" aria-hidden="true">
                  <use xlink:href="#svg-icon-menu"></use>
                </svg>
              </button>
            </div>
            <div class="col-auto"><router-link to="/" class="svg-icon header__logo" aria-label="TTC">
                <svg role="img" width="70" height="38" aria-hidden="true">
                  <use xlink:href="#svg-logo"></use>
                </svg></router-link></div>
            <div class="col-auto">
              <button class="btn header__assistant" @click.prevent="openAssistant('assistant-helper')" type="button" :aria-label='$t("contactSupportSpec")'>
                <svg role="img" width="24" height="24" aria-hidden="true">
                  <use xlink:href="#svg-icon-assistant"></use>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="header__menu menu">
          <div class="menu__content">
            <div class="menu__top">
              <div class="d-block d-xl-none">
                <button class="btn svg-icon menu__close" @click.prevent="closeMenu" type="button" :aria-label='$t("closeMenu")'>
                  <svg role="img" width="14" height="14" aria-hidden="true">
                    <use xlink:href="#svg-icon-close"></use>
                  </svg>
                </button><router-link class="svg-icon header__logo" to="/" aria-label="TTC">
                  <svg role="img" width="63" height="24" aria-hidden="true">
                    <use xlink:href="#svg-logo-mobile"></use>
                  </svg></router-link>
              </div>
              <div class="d-none d-xl-block"><router-link class="svg-icon menu__logo" to="/" aria-label="TTC">
                  <svg role="img" width="109" height="58" aria-hidden="true">
                    <use xlink:href="#svg-logo"></use>
                  </svg></router-link>
                <button class="btn svg-icon menu__toggle" @click.prevent="toggleModal" type="button" :aria-label='$t("switchMenu")'>
                  <svg role="img" width="24" height="24" aria-hidden="true">
                    <use xlink:href="#svg-icon-menu"></use>
                  </svg>
                </button>
              </div>
            </div>
            <nav class="menu__nav">
              <ul class="list list_unstyled menu__list">
                <li class="list__item"><router-link class="link" to="/" active-class="active" :aria-label='$t("main")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-home"></use>
                      </svg></span><span class="link__text">{{$t("main")}}</span></router-link>
                </li>
                <li class="list__item"><router-link class="link" to="/finances" active-class="active" :aria-label='$t("finance")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-wallet"></use>
                      </svg></span><span class="link__text">{{$t("finance")}}</span></router-link>
                </li>
                <li class="list__item"><router-link class="link" to="/detailing" active-class="active" :aria-label='$t("details")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-poll"></use>
                      </svg></span><span class="link__text">{{$t("details")}}</span></router-link>
                </li>
                <li class="list__item"><router-link class="link" :class="{'new-messages': existUnreadMessage}" to="/messages" active-class="active" :aria-label='$t("messages")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-mail"></use>
                      </svg></span><span class="link__text">{{$t("messages")}}</span></router-link>
                </li>
                <li class="list__item"><router-link class="link" to="/profile" active-class="active" :aria-label='$t("profile")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-person"></use>
                      </svg></span><span class="link__text">{{$t("profile")}}</span></router-link>
                </li>
                <li class="list__item"><router-link class="link" to="/branches" active-class="active" :aria-label='$t("branches")'><span class="link__icon svg-icon" aria-hidden="true">
                  <svg version="1.1" role="img" width="24" height="24" aria-hidden="true" x="0px" y="0px"
                    viewBox="0 0 430.114 430.114" fill="#fff" xml:space="preserve">
                    <g>
                      <path id="Facebook_Places" d="M356.208,107.051c-1.531-5.738-4.64-11.852-6.94-17.205C321.746,23.704,261.611,0,213.055,0
                        C148.054,0,76.463,43.586,66.905,133.427v18.355c0,0.766,0.264,7.647,0.639,11.089c5.358,42.816,39.143,88.32,64.375,131.136
                        c27.146,45.873,55.314,90.999,83.221,136.106c17.208-29.436,34.354-59.259,51.17-87.933c4.583-8.415,9.903-16.825,14.491-24.857
                        c3.058-5.348,8.9-10.696,11.569-15.672c27.145-49.699,70.838-99.782,70.838-149.104v-20.262
                        C363.209,126.938,356.581,108.204,356.208,107.051z M214.245,199.193c-19.107,0-40.021-9.554-50.344-35.939
                        c-1.538-4.2-1.414-12.617-1.414-13.388v-11.852c0-33.636,28.56-48.932,53.406-48.932c30.588,0,54.245,24.472,54.245,55.06
                        C270.138,174.729,244.833,199.193,214.245,199.193z"/>
                    </g>
                  </svg>
                      </span><span class="link__text">{{$t("branches")}}</span></router-link>
                </li>
                <!-- <li class="list__item"><a class="link" @click.prevent.stop="openAssistant('assistant-helper')" :aria-label='$t("contactSupportSpec")'><span class="link__icon svg-icon" aria-hidden="true">
                      <svg role="img" width="24" height="24" aria-hidden="true">
                        <use xlink:href="#svg-icon-assistant"></use>
                      </svg></span><span class="link__text">{{$t("assistant")}}</span></a>
                </li> -->
              </ul>
            </nav>
            <div class="menu__footer"><a class="link link_exit" @click="logout" :aria-label='$t("exit")'><span class="link__icon svg-icon" aria-hidden="true">
                  <svg role="img" width="24" height="24" aria-hidden="true">
                    <use xlink:href="#svg-icon-exit"></use>
                  </svg></span><span class="link__text">{{$t("exit")}}</span></a></div>
          </div>
        </div>
    </header>
</template>
<script>
const bodyElem = document.querySelector('body');
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  methods: {
    ...mapActions({
      getMessages: 'messages/getMessages',
      logoff: 'authorization/logout',
    }),
    ...mapMutations({
      setAssistantType: 'assistant/setAssistantType'
    }),
    logout: function () {
      this.logoff().then(() => {
        window.parent.postMessage("logout", "*");
        this.$router.push('/login')
      })
    },
    openAssistant(assistantType) {
      if (!window.matchMedia("(min-width: 1px) and (max-width: 1199px)").matches) {
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove('assistant-hide')
      }else{
        bodyElem.classList.contains('assistant-hide') && bodyElem.classList.remove('assistant-hide')
        bodyElem.classList.contains('assistant-open') || bodyElem.classList.add('assistant-open')
      }
      this.setAssistantType(assistantType)
    },
    openMenu() {
      bodyElem.classList.contains('menu-open') || bodyElem.classList.add('menu-open')
    },
    closeMenu() {
      bodyElem.classList.contains('menu-open') && bodyElem.classList.remove('menu-open')
    },
    toggleModal(){
      bodyElem.classList.toggle('menu-hide');
    }
  },
  computed: {
    ...mapGetters({
      existUnreadMessage: 'messages/existUnreadMessage',
      isAuthenticated: 'authorization/isAuthenticated'
    })
  },
  mounted() {
    if (this.isAuthenticated){
      this.getMessages();
    }
  }
}
</script>
<style scoped>
.link_exit{
  cursor: pointer;
}
.menu{
  transition: all .2s ease-in-out;
}
</style>